import { useEffect } from 'react';
import { getTrialEndDateRequest } from 'modules/billing/actions';
import { selectTrialEndDate } from 'modules/billing/selectors';
import { Announcement } from 'ui/announcement';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserAccountType } from 'core/userContext';
import { USER_ACCOUNT_TYPES } from 'core/userContext/constants';
import { calculcateRemainingTrialDays } from '../utils';

export const TrialEndDateBannerAnnouncement = () => {
  const dispatch = useDispatch();
  const userAccountType = useSelector(selectUserAccountType);
  const trialEndDate = useSelector(selectTrialEndDate);
  const isProspect = userAccountType === USER_ACCOUNT_TYPES.Prospect;

  useEffect(() => {
    if (isProspect) {
      dispatch(getTrialEndDateRequest());
    }
  }, [isProspect, dispatch]);

  const shouldShowBanner = isProspect && trialEndDate;

  return shouldShowBanner ? (
    <Announcement data-test="trial-end-date-banner">
      {calculcateRemainingTrialDays(trialEndDate)}
    </Announcement>
  ) : null;
};
